<template>
  <div class="container">
    <h1 class="title">BioRender激活</h1>

    <!-- 文件导出入口 -->
    <div class="export-entry">
<!--      <span class="export-text">需要导出文件？</span>-->
      <button class="export-link" @click="goToExport">
        24小时高清无水印图片自助导出 →
      </button>
    </div>
    
    <!-- 任务列表入口 -->
    <div class="task-list-entry">
      <button class="task-list-link" @click="goToTaskList">
        查看导出任务列表 →
      </button>
    </div>

    <div class="card">
      <input v-model="code" class="input" type="text" placeholder="请输入激活码" />
      <input v-model="email" class="input" type="email" placeholder="请输入邮箱" />
      <!-- 原有激活逻辑已注释（备份）
      <button class="btn" @click="activate" :disabled="loading">激 活</button>
      -->
      <button class="btn" @click="showDirectConfirm" :disabled="loading">激 活</button>
      <div class="tip">
        <div class="tip-title">友情提示!</div>
        <div class="tip-content">
          已注册过的账号直接登录，点击刷新，点击Accpet（接受邀请）。如果是没注册过bio账号，点击邮箱的账号邀请链接按步骤去注册即后成为Lab会员。<span class="highlight">如果后续没有高级功能，可重新兑换激活！(激活码可以重复使用)</span>
        </div>
      </div>
    </div>
    
    <!--
    ========================================
    【备份】旧版确认弹窗（带复选框）
    如需恢复，取消注释此段代码，并注释掉下方的【新版强制阅读弹窗】
    ========================================
    <div v-if="showConfirmModal" class="modal-overlay">
      <div class="modal">
        <div class="modal-header">
          <h3>重要提醒</h3>
        </div>
        <div class="modal-body">
          <div class="warning-icon">⚠️</div>
          <p class="warning-text">请务必确认所输入的账号已经在BioRender网页登录，否则充值失败！</p>
          <p class="sub-text">卡密只能固定激活一个账号，卡密有效期以第一次激活时间为准。</p>
          <div class="checkbox-container">
            <input type="checkbox" id="confirmCheck" v-model="confirmed" />
            <label for="confirmCheck">我确认已在BioRender网页登录相应账号</label>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeConfirmModal">取消</button>
          <button class="confirm-btn" @click="confirmAction" :disabled="!confirmed || confirming">
            {{ confirming ? '执行中...' : '确认执行' }}
          </button>
        </div>
      </div>
    </div>
    -->

    <!--
    ========================================
    【新版】强制阅读确认弹窗（5秒倒计时）
    ========================================
    -->
    <div v-if="showConfirmModal" class="modal-overlay">
      <div class="modal force-read-modal">
        <div class="modal-body force-read-body">
          <div class="force-read-title">重要的事情说三遍：</div>
          <div class="force-read-content">
            <p class="force-read-line">先在Borender登录后，再激活！！！</p>
            <p class="force-read-line">先在Borender登录后，再激活！！！</p>
            <p class="force-read-line">先在Borender登录后，再激活！！！</p>
          </div>
        </div>
        <div class="modal-footer force-read-footer">
          <button class="cancel-btn" @click="closeConfirmModal">取消</button>
          <button class="confirm-btn" @click="executeDirectActivation" :disabled="confirmCountdown > 0 || confirming">
            {{ confirming ? '校验中...' : (confirmCountdown > 0 ? `激活(${confirmCountdown})` : '激活') }}
          </button>
        </div>
      </div>
    </div>
    
    <!-- 等待弹窗 -->
    <div v-if="showWaitingModal" class="modal-overlay">
      <div class="modal">
        <div class="modal-header">
          <h3>正在处理中...</h3>
        </div>
        <div class="modal-body">
          <div class="spinner"></div>
          <p>请耐心等待1-3分钟，正在为您充值Biorender会员！</p>
          <p class="sub-text">完成后将自动显示结果，请不要关闭此页面</p>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closeWaitingModal">取消等待</button>
        </div>
      </div>
    </div>

    <!-- 结果展示弹窗 -->
    <div v-if="showResultModal" class="modal-overlay">
      <div class="modal result-modal">
        <div class="modal-body">
          <div class="result-content">
            <p class="result-text">{{ taskResult }}</p>
            <div v-if="screenshotUrl" class="screenshot-container">
              <h4>执行截图：</h4>
              <img :src="screenshotUrl" alt="执行截图" class="screenshot" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" @click="closeResultModal">确定</button>
        </div>
      </div>
    </div>
    
    <!-- 公告弹窗 -->
    <AnnouncementModal 
      :visible="showAnnouncementModal" 
      :announcement="announcementData" 
      @close="closeAnnouncementModal" />
  </div>
</template>

<script>
import { validateCode, confirmAndExecute } from '@/api/verification'
import AnnouncementModal from '@/components/AnnouncementModal.vue'
import { getCurrentAnnouncement } from '@/api/announcement'

export default {
  name: 'ActivatePage',
  components: {
    AnnouncementModal
  },
  data() {
    return {
      code: '',
      email: '',
      loading: false,
      showConfirmModal: false,
      showWaitingModal: false,
      confirmed: false,
      confirming: false,
      taskResult: '',
      pollTimer: null,
      showResultModal: false,
      screenshotUrl: '',
      showAnnouncementModal: false,
      announcementData: {},
      isDirectMode: false,
      confirmCountdown: 0,
      countdownTimer: null
    }
  },
  
  mounted() {
    this.fetchAnnouncement();
  },
  
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
      this.countdownTimer = null
    }
  },
  
  methods: {
    async activate() {
      if(!this.code) {
        this.showErrorDialog('请输入激活码')
        return
      }
      if (!this.email) {
        this.showErrorDialog('请输入邮箱')
        return
      }
      
      // 前端邮箱格式验证
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailRegex.test(this.email)) {
        this.showErrorDialog('邮箱格式错误，请核对')
        return
      }
      
      this.loading = true
      try {
        const response = await validateCode({
          code: this.code,
          email: this.email,
          cardPassword: this.code,
          type: 'ACTIVATION'
        })

        
        if (response.success) {
          // 检查是否是重复激活的情况（包含"已激活过"字样的都需要二次确认）
          if (response.data && response.data.includes('已激活过')) {
            // 显示重复激活提示
            const continueActivation = confirm(response.data + '\n\n是否继续激活操作？')
            if (continueActivation) {
              this.showConfirmModal = true
            }
          } else {
            // 验证成功，显示确认弹窗
            this.showConfirmModal = true
          }
        } else {
          // 显示具体错误信息
          this.showErrorDialog(response.msg || '激活失败')
        }
      } catch (error) {
        console.error('激活请求失败:', error)
        // 如果是网络错误或其他异常，显示通用错误信息
        if (error.response && error.response.data && error.response.data.msg) {
          this.showErrorDialog(error.response.data.msg)
        } else {
          this.showErrorDialog('网络错误，请稍后重试')
        }
      } finally {
        this.loading = false
      }
    },

    async executeActivation() {
      this.confirming = true
      try {
        const response = await confirmAndExecute({
          code: this.code,
          email: this.email,
          cardPassword: this.code,
          confirmed: this.confirmed
        })

        if (response.success) {
          // 关闭确认弹窗，显示等待弹窗
          this.showConfirmModal = false
          this.showWaitingModal = true
          this.code = ''
          this.confirmed = false
          // 开始轮询任务结果
          this.startPolling()
        } else {
          // 显示具体错误信息
          this.showErrorDialog(response.msg || '执行失败')
        }
      } catch (error) {
        console.error('执行请求失败:', error)
        if (error.response && error.response.data && error.response.data.msg) {
          this.showErrorDialog(error.response.data.msg)
        } else {
          this.showErrorDialog('网络错误，请稍后重试')
        }
      } finally {
        this.confirming = false
      }
    },

    closeConfirmModal() {
      this.showConfirmModal = false
      this.confirmed = false
      this.isDirectMode = false
      // 清除倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      this.confirmCountdown = 0
    },

    // 显示直接激活的确认弹窗（先验证，再弹窗）
    async showDirectConfirm() {
      if (!this.code) {
        this.showErrorDialog('请输入激活码')
        return
      }
      if (!this.email) {
        this.showErrorDialog('请输入邮箱')
        return
      }

      // 前端邮箱格式验证
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailRegex.test(this.email)) {
        this.showErrorDialog('邮箱格式错误，请核对')
        return
      }

      this.loading = true
      try {
        // 先调用验证接口
        const response = await fetch('/api/v1/verification-codes/activity-invite-verify', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            code: this.code,
            email: this.email
          })
        })

        const result = await response.json()

        if (result.success) {
          // 验证成功，显示确认弹窗并开始倒计时
          this.isDirectMode = true
          this.showConfirmModal = true
          this.startConfirmCountdown()
        } else {
          // 验证失败，显示错误消息
          this.showErrorDialog(result.data || result.msg || '激活码验证失败')
        }
      } catch (error) {
        console.error('验证请求失败:', error)
        this.showErrorDialog('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 开始确认弹窗倒计时（5秒）
    startConfirmCountdown() {
      this.confirmCountdown = 5
      this.countdownTimer = setInterval(() => {
        this.confirmCountdown--
        if (this.confirmCountdown <= 0) {
          clearInterval(this.countdownTimer)
          this.countdownTimer = null
        }
      }, 1000)
    },

    // 根据模式执行对应的激活方法
    confirmAction() {
      if (this.isDirectMode) {
        this.executeDirectActivation()
      } else {
        this.executeActivation()
      }
    },

    // 直接调用新接口的激活方法
    async executeDirectActivation() {
      this.confirming = true
      try {
        const response = await fetch('/api/v1/verification-codes/activity-invite-cardpwd', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            code: this.code,
            email: this.email
          })
        })

        const result = await response.json()

        if (result.success) {
          // 关闭确认弹窗，显示等待弹窗
          this.showConfirmModal = false
          this.confirmed = false
          this.isDirectMode = false
          this.showWaitingModal = true
          this.code = ''
          // 开始轮询任务结果
          this.startPolling()
        } else {
          // 显示具体错误信息
          this.showErrorDialog(result.msg || '激活失败')
        }
      } catch (error) {
        console.error('激活请求失败:', error)
        if (error.response && error.response.data && error.response.data.msg) {
          this.showErrorDialog(error.response.data.msg)
        } else {
          this.showErrorDialog('网络错误，请稍后重试')
        }
      } finally {
        this.confirming = false
      }
    },
    
    startPolling() {
      
      // 每5秒轮询一次任务结果
      this.pollTimer = setInterval(async () => {
        try {
          const response = await fetch(`/api/automation/result/${this.email}`)
          
          if (!response.ok) {
            return
          }
          
          const result = await response.json()
          
          if (result.success && result.data) {
            if (result.data.completed) {
              // 任务完成，停止轮询
              clearInterval(this.pollTimer)
              this.pollTimer = null
              this.showWaitingModal = false
              
              // 根据不同的返回结果显示相应的反馈信息
              let feedbackMessage = ''
              let shouldShowScreenshot = false
              
              if (result.data.result === 'Invite sent') {
                feedbackMessage = '请点击浏览器中的"刷新"，点击"Accept"即可成为会员！'
                shouldShowScreenshot = true
              } else if (result.data.result === 'User already invited') {
                feedbackMessage = '请点击浏览器中的"刷新"，点击"Accept"即可成为会员！'
                shouldShowScreenshot = true
              } else if (result.data.result === 'User is part of another organization') {
                feedbackMessage = '您目前仍是会员无需激活！'
                shouldShowScreenshot = false
              } else if (result.data.result === 'User is already part of this organization') {
                feedbackMessage = '您目前仍是会员无需激活！'
                shouldShowScreenshot = false
              } else {
                // 其他情况（包括失败情况）都显示超时提示
                clearInterval(this.pollTimer)
                this.pollTimer = null
                this.showWaitingModal = false
                this.taskResult = '等待超时，重新进行激活'
                this.screenshotUrl = ''
                this.showResultModal = true
                this.email = ''
                return
              }
              
              this.taskResult = feedbackMessage
              
              // 根据结果决定是否显示截图
              if (shouldShowScreenshot) {
                this.screenshotUrl = require('@/assets/dialog.jpg')
              } else {
                this.screenshotUrl = ''
              }
              
              this.showResultModal = true
              this.email = ''
            } else {
              // 任务尚未完成，继续轮询
            }
          } else if (result.success === false) {
            // 继续轮询，可能任务还未创建
          } else {
            // 任务状态未知，继续轮询
          }
        } catch (error) {
          // 网络错误不中断轮询，继续尝试
        }
      }, 5000)
      
      // 3分钟后超时
      setTimeout(() => {
        if (this.pollTimer) {
          clearInterval(this.pollTimer)
          this.pollTimer = null
          this.showWaitingModal = false
          this.taskResult = '任务执行超时，请稍后刷新BioRender界面查看结果。如果仍未成功，请重新激活。'
          this.screenshotUrl = ''
          this.showResultModal = true
          this.email = ''
        }
      }, 180000) // 3分钟
    },
    
    closeWaitingModal() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
      this.showWaitingModal = false
      this.email = ''
    },

    showErrorDialog(message) {
      // 使用更好看的错误提示
      alert(message)
    },

    closeResultModal() {
      this.showResultModal = false
      this.taskResult = ''
      this.screenshotUrl = ''
    },

    goToExport() {
      this.$router.push('/export')
    },
    
    goToTaskList() {
      this.$router.push('/export/tasks')
    },
    
    async fetchAnnouncement() {
      try {
        const response = await getCurrentAnnouncement();
        if (response.success && response.data) {
          this.announcementData = response.data;
          // 每次都显示公告弹窗（如果存在启用的公告）
          this.showAnnouncementModal = true;
        }
      } catch (error) {
        console.error('获取公告失败:', error);
      }
    },
    
    closeAnnouncementModal() {
      this.showAnnouncementModal = false;
    }
  }
}
</script>

<style scoped>
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f7f8fa;
}
.title {
  color: #2176c7;
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 24px;
  text-align: center;
}

/* 文件导出入口 */
.export-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
}

.export-link {
  display: inline-block;
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 20px;
  color: #666;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.export-link:hover {
  background: #e9ecef;
  color: #2176c7;
  border-color: #2176c7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.export-link:active {
  transform: translateY(0);
}

/* 任务列表入口 */
.task-list-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.task-list-link {
  display: inline-block;
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 20px;
  color: #666;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.task-list-link:hover {
  background: #e9ecef;
  color: #2176c7;
  border-color: #2176c7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.task-list-link:active {
  transform: translateY(0);
}

.card {
  background: #fff;
  padding: 32px 24px 24px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.input {
  height: 40px;
  margin-bottom: 16px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 16px;
}
.btn {
  height: 40px;
  background: #2176c7;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background 0.2s;
}
.btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
.btn:hover {
  background: #185a9d;
}
.tip {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
  border-radius: 4px;
  padding: 12px 16px;
  font-size: 15px;
}
.tip-title {
  font-weight: bold;
  margin-bottom: 4px;
}
.highlight {
  color: #d9534f;
  font-weight: bold;
}

/* 弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  padding: 20px 24px 0;
  text-align: center;
}

.modal-header h3 {
  margin: 0;
  color: #2176c7;
  font-size: 20px;
}

.modal-body {
  padding: 20px 24px;
  text-align: center;
}

.modal-body p {
  margin: 10px 0;
  color: #333;
  line-height: 1.5;
}

.sub-text {
  font-size: 14px;
  color: #666;
}

.modal-footer {
  padding: 0 24px 20px;
  text-align: center;
}

.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-btn:hover {
  background: #e8e8e8;
}

/* 加载动画 */
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2176c7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 确认弹窗样式 */
.warning-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.warning-text {
  color: #d9534f;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 12px;
}

.checkbox-container {
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.checkbox-container input[type="checkbox"] {
  width: 16px;
  height: 16px;
}

.checkbox-container label {
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.confirm-btn {
  background: #d9534f;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
  margin-left: 8px;
}

.confirm-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.confirm-btn:hover:not(:disabled) {
  background: #c9302c;
}

/* 结果弹窗样式 */
.result-modal {
  width: 500px;
  max-width: 95%;
}

.result-content {
  text-align: left;
}

.result-text {
  background: #f0f9ff;
  border: 1px solid #0284c7;
  border-radius: 4px;
  padding: 12px;
  margin: 16px 0;
  color: #0284c7;
  font-weight: 500;
  white-space: pre-wrap;
}

.result-tip {
  color: #666;
  font-size: 14px;
  margin-bottom: 16px;
}

.screenshot-container {
  margin-top: 20px;
}

.screenshot-container h4 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 14px;
}

.screenshot {
  max-width: 100%;
  max-height: 300px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .title {
    font-size: 36px;
    margin-bottom: 20px;
  }

  .export-entry {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
  }

  .card {
    width: 100%;
    max-width: 350px;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 16px;
  }

  .title {
    font-size: 28px;
    margin-bottom: 16px;
  }

  .export-entry {
    font-size: 13px;
  }

  .export-link {
    font-size: 13px;
  }
}

/* ==================== 强制阅读弹窗样式 ==================== */
.force-read-modal {
  max-width: 400px;
}

.force-read-body {
  padding: 30px 24px;
  text-align: center;
}

.force-read-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.force-read-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.force-read-line {
  font-size: 16px;
  font-weight: 500;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.force-read-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 0 24px 24px;
}

.force-read-footer .cancel-btn,
.force-read-footer .confirm-btn {
  min-width: 100px;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.force-read-footer .cancel-btn {
  background: #fff;
  color: #666;
  border: 1px solid #ddd;
}

.force-read-footer .cancel-btn:hover {
  background: #f5f5f5;
}

.force-read-footer .confirm-btn {
  background: #2176c7;
  color: #fff;
  border: none;
}

.force-read-footer .confirm-btn:hover:not(:disabled) {
  background: #1a5fa3;
}

.force-read-footer .confirm-btn:disabled {
  background: #a0aec0;
  cursor: not-allowed;
}
</style> 